import { render, staticRenderFns } from "./MatrixView.vue?vue&type=template&id=4d0ae754&scoped=true&"
import script from "./MatrixView.vue?vue&type=script&lang=js&"
export * from "./MatrixView.vue?vue&type=script&lang=js&"
import style0 from "./MatrixView.vue?vue&type=style&index=0&id=4d0ae754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0ae754",
  null
  
)

/* custom blocks */
import block0 from "./MatrixView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d0ae754')) {
      api.createRecord('4d0ae754', component.options)
    } else {
      api.reload('4d0ae754', component.options)
    }
    module.hot.accept("./MatrixView.vue?vue&type=template&id=4d0ae754&scoped=true&", function () {
      api.rerender('4d0ae754', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/matrix/MatrixView.vue"
export default component.exports